<template>
  <div class="footer-box">
    <div class="footer">
      <p>
        学院办公室电话：0566-2092439　　招生就业与校企合作处：0566-2091931 &nbsp;&nbsp;&nbsp;&nbsp;  地址：安徽省池州市建设西路389号（西门），虎泉路（东门）　邮编：247000
        <br/>非经营性教育信息网站前置审批号：安徽省教育厅皖教秘科【2011】41号  &nbsp;&nbsp;&nbsp;&nbsp;非经营性 ICP 备案号：<a href="http://www.miitbeian.gov.cn/state/outPortal/loginPortal.action;jsessionid=jUpKToukN2lqWTcin0MgCMGuZHYEJXUhsSn77b7HWXhbfjbAPhNE!-2113647171" target="_blank">皖ICP备11021113号-1</a>
        <br/><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34170002000066" target="_blank"><span></span>皖公网安备 34170002000066号</a>     池州职业技术学院图文信息中心制作维护
        <a href="http://bszs.conac.cn/sitename?method=show&id=0973505E8DDD6365E053022819AC8FD2" target="_blank"><img class="blue" src="../assets/imgs/blue.png" /></a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "foot"
};
</script>

<style scoped>
/*底部*/
.footer-box {
  width: 100%;
  height: 120px;
  background: #428bca;
  min-width: 1200px;
  text-align: center;
}
.footer {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  color: #ffffff;
  line-height: 30px;
  font-size: 12px;
  padding: 20px 0;
  position: relative;
}
.footer a {
  color: #ffffff;
  margin-right: 10px;
}
.footer a:hover {
  color: yellow;
}
.footer a span {
  width: 20px;
  height: 20px;
  display: inline-block;
  background: url("../assets/imgs/ga_beian.png") no-repeat;
  margin-right: 10px;
  vertical-align: middle;
}
.footer .blue {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/footComp.vue